import { EndpointQueryParameters } from '../../../types/strapi/strapi'

export const defaultParams: EndpointQueryParameters = {
    populate: {
        client: {
            fields: ['documentId', 'name'],
        },
        manager: {
            fields: ['documentId', 'username'],
        },
        user_audit: {
            populate: {
                created_by_permissions_user: {
                    fields: ['documentId', 'username'],
                },
            },
        },
        order_items: {
            fields: ['documentId', 'name'],
            populate: {
                product_type: {
                    fields: ['documentId', 'name', 'slug'],
                },
                ribbon: {
                    fields: ['documentId', 'specs'],
                },
                shipment_position: {
                    fields: ['documentId', 'labelName'],
                },
            },
        },
    },
    sort: ['createdAt:desc'],
}

export const orderDetailParams: EndpointQueryParameters = {
    populate: {
        client: {
            fields: ['documentId', 'name'],
        },
        manager: {
            fields: ['documentId', 'username'],
        },
        user_audit: {
            populate: {
                created_by_permissions_user: {
                    fields: ['documentId', 'username'],
                },
            },
        },
        order_items: {
            fields: [
                'documentId',
                'name',
                'quantity',
                'unit',
                'itemStatus',
                'approvedPrice',
                'productionDueDate',
            ],
            populate: {
                product_type: {
                    fields: ['documentId', 'name', 'slug'],
                },
                ribbon: {
                    fields: ['documentId', 'specs'],
                    populate: {
                        cost: true,
                    },
                },
                stamp: {
                    fields: ['documentId', 'number'],
                },
                form_set: {
                    fields: ['documentId', 'id'],
                },
                shipment_position: {
                    fields: ['documentId', 'labelName', 'copies'],
                    populate: {
                        shipment: {
                            fields: ['documentId'],
                            populate: {
                                calculated: true,
                                shipment_positions: { fields: ['documentId', 'copies'] },
                            },
                        },
                    },
                },
            },
        },
    },
}
